<template>
  <v-container pa-6>
    <v-layout wrap>
      <v-flex sm12 class="primary--text title">
        <p>{{ participant.name }}</p>
      </v-flex>
      <v-flex sm12 class="primary--text title">
        <p>{{ participant.work }}</p>
      </v-flex>
      <v-flex sm6 offset-sm3 mb-10>
        <v-card height="50vh" class="pa-6">
          <v-layout v-if="activeCard" wrap style="height:100%">
            <v-layout wrap v-if="!finished">
              <v-flex sm10>
                <p class="text-justify">{{ reactives[actual].title }}</p>
              </v-flex>

              <!--
							<v-layout wrap class="d-flex align-end mb-12">
								<v-flex sm12 class="text-center">
									<v-btn @click="addAnswer(1)" class="primary">Si</v-btn>
								</v-flex>
								<v-flex sm12 class="text-center">
									<v-btn @click="addAnswer(0)" class="primary">No</v-btn>
								</v-flex>
							</v-layout>
              -->
              <v-flex sm12>
                <v-form @submit.prevent="addAnswer" ref="form">
                  <v-flex sm12>
                    <v-btn class="primary" style="margin-right:10px">1 = Sí</v-btn>
                    <v-btn class="primary">0 = No</v-btn>
                  </v-flex>

                  <v-flex sm12>
                    <v-text-field
                      v-model="answer"
                      label="respuesta"
                      :rules="requiredRule"
                      autofocus
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12>
                    <v-btn class="primary" type="submit">Continuar</v-btn>
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
            <div v-else>
              <p>Has terminado</p>
            </div>
          </v-layout>
          <v-layout wrap v-else>
            <p>Cargando..</p>
          </v-layout>
        </v-card>
      </v-flex>

      <v-snackbar v-model="snackbar" right top :timeout="3000">
        {{ message }}
        <v-btn color="blue" text @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      requiredRule: [
        v => !!v || "Este campo es obligatorio",
        v => v == 0 || v == 1 || "El valor debe ser 0: no o 1: sí"
      ],
      editor: null,
      snackbar: false,
      reactives: [],
      answers: [],
      activeCard: false,
      answer: null,
      message: "",
      actual: 0,
      timer: 0,
      finished: false,
      idInterval: null,
      participant: JSON.parse(sessionStorage.getItem("clientParticipant")),
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    send() {
      this.finished = true;
      const fd = new FormData();

      for (let i = 0; i < this.answers.length; i++) {
        fd.append("answers[]", this.answers[i]);
        fd.append("idReactives[]", this.reactives[i].idReactive);
      }
      fd.append("idParticipant", this.participant.idParticipant);
      fd.append("idUser", sessionStorage.getItem("authorization"));
      fd.append("date", new Date() + "");

      axios
        .post(this.host + "/answers/create.php", fd)
        .then(response => {
          this.snackbar = true;
          this.message = response.data.message;
          if (response.data.status) {
            sessionStorage.removeItem("participant");
            this.restart();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    restart() {
      setTimeout(() => {
        this.$router.push("/client/massive");
      }, 500);
    },
    addAnswer() {
      if (this.$refs.form.validate()) {
        let val = null;
        if (this.answer == 1) {
          val = 1;
        } else if (this.answer == 0) {
          val = 0;
        }

        this.answers.push(val);
        this.actual++;
        this.answer = null;
        this.$refs.form.resetValidation();

        if (this.answers.length < this.reactives.length) {
          if (
            this.answers[0] == 0 &&
            this.answers[1] == 0 &&
            this.answers[2] == 0 &&
            this.answers[3] == 0 &&
            this.answers[4] == 0 &&
            this.answers[5] == 0
          ) {
            this.send();
          } else {
            if (this.reactives[this.actual].timer == 0) {
              this.timer = 0;
            } else {
              this.timer = this.reactives[this.actual].timer;
            }
          }
        } else {
          //se acabaron las preguntas
          clearInterval(this.idInterval);
          this.send();
        }
      }
    },
    timerFunction() {
      this.idInterval = setInterval(() => {
        if (this.timer <= 1) {
          clearInterval(this.idInterval);
          this.timer = 0;
          this.addAnswer(0);
        } else {
          this.timer--;
        }
      }, 1000);
    },
    getData() {
      this.activeCard = false;
      axios
        .get(this.host + "/reactives/read.php")
        .then(response => {
          this.reactives = response.data.data;
          this.activeCard = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style scoped>
.background {
  position: relative;
  background-color: rgba(0, 0, 0, 0.5);
  height: 95%;
  width: 100%;
  z-index: 100;
}

.front {
  position: relative;
  z-index: 10;
}
</style>